import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Hammer from '@egjs/hammerjs';
import { MULTI_FINGER_PAN_MAX_PINCH_THRESHOLD, MULTI_FINGER_PAN_MAX_ROTATION_THRESHOLD } from "./constants";
import DraggingGestureHandler from "./DraggingGestureHandler";
import { isValidNumber, isnan, TEST_MIN_IF_NOT_NAN, VEC_LEN_SQ } from "./utils";
import State from "../State";

var PanGestureHandler = function (_DraggingGestureHandl) {
  _inherits(PanGestureHandler, _DraggingGestureHandl);

  var _super = _createSuper(PanGestureHandler);

  function PanGestureHandler() {
    _classCallCheck(this, PanGestureHandler);

    return _super.apply(this, arguments);
  }

  _createClass(PanGestureHandler, [{
    key: "getHammerConfig",
    value: function getHammerConfig() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(PanGestureHandler.prototype), "getHammerConfig", this).call(this)), {}, {
        direction: this.getDirection()
      });
    }
  }, {
    key: "getState",
    value: function getState(type) {
      var nextState = _get(_getPrototypeOf(PanGestureHandler.prototype), "getState", this).call(this, type);

      if (this.previousState === State.UNDETERMINED && nextState === State.ACTIVE) {
        return State.BEGAN;
      }

      return nextState;
    }
  }, {
    key: "getDirection",
    value: function getDirection() {
      var config = this.getConfig();
      var activeOffsetXStart = config.activeOffsetXStart,
          activeOffsetXEnd = config.activeOffsetXEnd,
          activeOffsetYStart = config.activeOffsetYStart,
          activeOffsetYEnd = config.activeOffsetYEnd,
          minDist = config.minDist;
      var directions = [];
      var horizontalDirections = [];

      if (!isnan(minDist)) {
        return Hammer.DIRECTION_ALL;
      }

      if (!isnan(activeOffsetXStart)) horizontalDirections.push(Hammer.DIRECTION_LEFT);
      if (!isnan(activeOffsetXEnd)) horizontalDirections.push(Hammer.DIRECTION_RIGHT);
      if (horizontalDirections.length === 2) horizontalDirections = [Hammer.DIRECTION_HORIZONTAL];
      directions = directions.concat(horizontalDirections);
      var verticalDirections = [];
      if (!isnan(activeOffsetYStart)) verticalDirections.push(Hammer.DIRECTION_UP);
      if (!isnan(activeOffsetYEnd)) verticalDirections.push(Hammer.DIRECTION_DOWN);
      if (verticalDirections.length === 2) verticalDirections = [Hammer.DIRECTION_VERTICAL];
      directions = directions.concat(verticalDirections);

      if (!directions.length) {
        return Hammer.DIRECTION_NONE;
      }

      if (directions[0] === Hammer.DIRECTION_HORIZONTAL && directions[1] === Hammer.DIRECTION_VERTICAL) {
        return Hammer.DIRECTION_ALL;
      }

      if (horizontalDirections.length && verticalDirections.length) {
        return Hammer.DIRECTION_ALL;
      }

      return directions[0];
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      if (!this._hasCustomActivationCriteria) {
        return {
          minDistSq: 10
        };
      }

      return this.config;
    }
  }, {
    key: "shouldFailUnderCustomCriteria",
    value: function shouldFailUnderCustomCriteria(_ref, criteria) {
      var deltaX = _ref.deltaX,
          deltaY = _ref.deltaY;
      return !isnan(criteria.failOffsetXStart) && deltaX < criteria.failOffsetXStart || !isnan(criteria.failOffsetXEnd) && deltaX > criteria.failOffsetXEnd || !isnan(criteria.failOffsetYStart) && deltaY < criteria.failOffsetYStart || !isnan(criteria.failOffsetYEnd) && deltaY > criteria.failOffsetYEnd;
    }
  }, {
    key: "shouldActivateUnderCustomCriteria",
    value: function shouldActivateUnderCustomCriteria(_ref2, criteria) {
      var deltaX = _ref2.deltaX,
          deltaY = _ref2.deltaY,
          velocity = _ref2.velocity;
      return !isnan(criteria.activeOffsetXStart) && deltaX < criteria.activeOffsetXStart || !isnan(criteria.activeOffsetXEnd) && deltaX > criteria.activeOffsetXEnd || !isnan(criteria.activeOffsetYStart) && deltaY < criteria.activeOffsetYStart || !isnan(criteria.activeOffsetYEnd) && deltaY > criteria.activeOffsetYEnd || TEST_MIN_IF_NOT_NAN(VEC_LEN_SQ({
        x: deltaX,
        y: deltaY
      }), criteria.minDistSq) || TEST_MIN_IF_NOT_NAN(velocity.x, criteria.minVelocityX) || TEST_MIN_IF_NOT_NAN(velocity.y, criteria.minVelocityY) || TEST_MIN_IF_NOT_NAN(VEC_LEN_SQ(velocity), criteria.minVelocitySq);
    }
  }, {
    key: "shouldMultiFingerPanFail",
    value: function shouldMultiFingerPanFail(_ref3) {
      var pointerLength = _ref3.pointerLength,
          scale = _ref3.scale,
          deltaRotation = _ref3.deltaRotation;

      if (pointerLength <= 1) {
        return false;
      }

      var deltaScale = Math.abs(scale - 1);
      var absDeltaRotation = Math.abs(deltaRotation);

      if (deltaScale > MULTI_FINGER_PAN_MAX_PINCH_THRESHOLD) {
        return true;
      }

      if (absDeltaRotation > MULTI_FINGER_PAN_MAX_ROTATION_THRESHOLD) {
        return true;
      }

      return false;
    }
  }, {
    key: "updateHasCustomActivationCriteria",
    value: function updateHasCustomActivationCriteria(criteria) {
      return isValidNumber(criteria.minDistSq) || isValidNumber(criteria.minVelocityX) || isValidNumber(criteria.minVelocityY) || isValidNumber(criteria.minVelocitySq) || isValidNumber(criteria.activeOffsetXStart) || isValidNumber(criteria.activeOffsetXEnd) || isValidNumber(criteria.activeOffsetYStart) || isValidNumber(criteria.activeOffsetYEnd);
    }
  }, {
    key: "isGestureEnabledForEvent",
    value: function isGestureEnabledForEvent(props, recognizer, inputData) {
      if (this.shouldFailUnderCustomCriteria(inputData, props)) {
        return {
          failed: true
        };
      }

      var velocity = {
        x: inputData.velocityX,
        y: inputData.velocityY
      };

      if (this._hasCustomActivationCriteria && this.shouldActivateUnderCustomCriteria({
        deltaX: inputData.deltaX,
        deltaY: inputData.deltaY,
        velocity: velocity
      }, props)) {
        if (this.shouldMultiFingerPanFail({
          pointerLength: inputData.maxPointers,
          scale: inputData.scale,
          deltaRotation: inputData.deltaRotation
        })) {
          return {
            failed: true
          };
        }

        return {
          success: true
        };
      }

      return {
        success: false
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'pan';
    }
  }, {
    key: "NativeGestureClass",
    get: function get() {
      return Hammer.Pan;
    }
  }]);

  return PanGestureHandler;
}(DraggingGestureHandler);

function validateConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isNum = function isNum(v) {
    return isnan(v) || typeof v === 'number';
  };

  var isBool = function isBool(v) {
    return typeof v === 'boolean';
  };

  var valid = {
    enabled: isBool,
    minDistSq: isNum,
    minVelocityX: isNum,
    minVelocityY: isNum,
    minVelocity: isNum,
    minVelocitySq: isNum,
    activeOffsetXStart: isNum,
    activeOffsetXEnd: isNum,
    failOffsetXStart: isNum,
    failOffsetXEnd: isNum,
    activeOffsetYStart: isNum,
    activeOffsetYEnd: isNum,
    failOffsetYStart: isNum,
    failOffsetYEnd: isNum,
    hasCustomActivationCriteria: isBool,
    minPointers: isNum,
    maxPointers: isNum
  };
  var keys = Object.keys(valid);
  var invalidKeys = [];

  for (var _i = 0, _Object$keys = Object.keys(config); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];

    if (keys.includes(key)) {
      if (valid[key](config[key])) {
        console.warn('Invalid type: ' + key + ': ' + config[key]);
      }
    } else {
      invalidKeys.push(key);
    }
  }

  if (invalidKeys.length) {
    throw new Error('Invalid config props found: ' + invalidKeys.join(', '));
  }

  return config;
}

export default PanGestureHandler;